<div class="w-full sm:max-w-2xl">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-2">
        <mat-form-field class="col-span-1">
            <mat-label>{{ 'label_pension_benefit_acquisition_type' | translate }}</mat-label>
            <mat-select (selectionChange)="onOptionsChange()" [(value)]="selectedAcquisitionType">
                @for (item of acquisitionTypeOptions; track item) {
                    <mat-option [value]="item"> {{ item }} </mat-option>
                }
            </mat-select>
        </mat-form-field>
        @if (selectedAcquisitionType == 'JA') {
            <mat-form-field class="col-span-1">
                <mat-label>{{ 'label_period' | translate }}</mat-label>
                <mat-select (selectionChange)="onOptionsChange()" [(value)]="selectedPeriod">
                    @for (item of periodOptions; track item) {
                        <mat-option [value]="item.value">
                            {{ item.viewValue }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }
        @if (selectedAcquisitionType == 'JA' && selectedPeriod == '>2023') {
            <mat-form-field class="col-span-1">
                <mat-label>{{ 'label_zero_point' | translate }}</mat-label>
                <mat-select (selectionChange)="onOptionsChange()" [(value)]="selectedZeroPoint">
                    @for (item of zeroPointOptions; track item) {
                        <mat-option [value]="item.value">
                            {{ item.viewValue }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }
    </div>
    <table matSort mat-table [dataSource]="displayedDataSource" class="w-full">
        <ng-container matColumnDef="age">
            <th mat-header-cell *matHeaderCellDef>
                {{ 'label_age' | translate }}
            </th>
            <td mat-cell *matCellDef="let item">{{ item.age ?? '-' }}</td>
        </ng-container>
        <ng-container matColumnDef="monthlyCoefficient">
            <th mat-header-cell *matHeaderCellDef>
                {{ 'label_monthly_coefficient' | translate }}
            </th>
            <td mat-cell *matCellDef="let item">
                {{ item.monthlyCoefficient }}
            </td>
        </ng-container>
        <ng-container matColumnDef="accumulatedCoefficient">
            <th mat-header-cell *matHeaderCellDef>
                {{ 'label_accumulative_coefficient' | translate }}
            </th>
            <td mat-cell *matCellDef="let item">
                {{ item.accumulatedCoefficient.roundTo(4) }}
            </td>
        </ng-container>
        <ng-container matColumnDef="payoutMultiplier">
            <th mat-header-cell *matHeaderCellDef>
                {{ 'label_payout_multiplier' | translate }}
            </th>
            <td mat-cell *matCellDef="let item">
                {{ (1 + item.accumulatedCoefficient).roundTo(4) }}
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
    </table>
</div>
